import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { HttpClient, } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DomainCacheService } from './domain-cache.service';

const baseRef = 'tipo-associacao';
const route = {
  listar: `${baseRef}`
};

export interface TipoAssociacao {
  codigo: number;
  nome: string;
}


@Injectable({
  providedIn: 'root'
})
export class TipoAssociacaoService {

  constructor(
    private apiService: ApiService,
    private http: HttpClient,
    private domainCache: DomainCacheService
  ) { }

  list(): Observable<TipoAssociacao[]> {
    return this.domainCache.getOrLoad(route.listar, () =>
      this.apiService.get<TipoAssociacao[]>(`${route.listar}`, undefined, undefined, true)
    );
  }
}
